/**
 * Shared source of truth for the 5 pan-Asian Country Hub pages.
 * Used by:
 *   • /pages/Home.jsx — compact section
 *   • /pages/Services.jsx — full CountryCoverage
 *   • /pages/guides/GuideArticle.jsx — "Explore by country"
 *   • /pages/blog/BlogArticle.jsx — inter-hub PeerCountryHubs
 *   • /components/blog/BlogDiscovery.jsx — "Country Hubs" tab
 *
 * Order is intentional — Vietnam and Indonesia lead (highest B2B demand
 * validated by DataForSEO research). China is included as a coverage
 * marker but has no dedicated hub (already covered across every service
 * page and comparative article).
 */

export const COUNTRY_HUBS = [
  {
    code: "vietnam",
    label: "Vietnam",
    lead: "Furniture, textiles, footwear, electronics",
    hubSlug: "sourcing-from-vietnam-hub",
  },
  {
    code: "indonesia",
    label: "Indonesia",
    lead: "Wood furniture, home goods, apparel, food",
    hubSlug: "sourcing-from-indonesia-hub",
  },
  {
    code: "thailand",
    label: "Thailand",
    lead: "Garment, automotive parts, rubber, electronics",
    hubSlug: "sourcing-from-thailand-hub",
  },
  {
    code: "malaysia",
    label: "Malaysia",
    lead: "Semiconductor, palm derivatives, medical devices",
    hubSlug: "sourcing-from-malaysia-hub",
  },
  {
    code: "philippines",
    label: "Philippines",
    lead: "Furniture (Cebu), garments, food processing",
    hubSlug: "sourcing-from-philippines-hub",
  },
];

/** China is represented across every service page and comparative
 * article; we do not render a dedicated hub for it. Kept here for the
 * full CountryCoverage grid on the Services page only. */
export const CHINA_COVERAGE = {
  code: "china",
  label: "China",
  lead: "Broad manufacturing; cautionary sourcing frame",
  hubSlug: null,
};

export function hubHref(code) {
  const c = COUNTRY_HUBS.find((h) => h.code === code);
  return c ? `/blog/${c.hubSlug}` : null;
}
